import styled from 'styled-components/macro';

export const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

export const RowCenter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const OptionDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: transparent;
  white-space: nowrap;
  -webkit-tap-highlight-color: transparent;

  border-radius: 5px;
  border: 1px solid #11202B;
  padding-left: 20px;
  padding-right: 20px;
  height: 42px;
  width: fit-content;
`;

export const OptionInput = styled.input`
  font-family: Squad-Regular, Squad;
  font-weight: 400;
  font-size: 16px;
  color: #11202B;
  border: none;
  background: transparent;
`;
